/**
 * web
 */
'use strict';
import '@/_modules/Define';
import {breakpoint, assets_path} from '@/_constant/variables';
import ImgLoaded from '@/_modules/ImgLoaded';
import AppVue from '@/_modules/app_vue';

// ブラウザ処理
document.addEventListener('DOMContentLoaded', () => {
  /** youtube iframe api */
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}, false);

window.addEventListener('load', () => {
  new AppVue();
}, false);

window.addEventListener('unload', () => {}, false);

window.onpageshow = function(event) {
  /*if (event.persisted) {
    window.location.reload();
  }*/
};

window.onYouTubeIframeAPIReady = function() {
  window.gSLANTED.isReadyYT = true;
};

Number.isNaN = Number.isNaN || function(any) {
  return typeof any === 'number' && isNaN(any);
};

Number.prototype.map = function(in_min, in_max, out_min, out_max) {
  return ((this - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
};
